import React from 'react';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  const scrollToBuy = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-6 pb-10 px-4 max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-87">
      <h1 className="text-3xl md:text-5xl font-oswald font-bold leading-tight md:leading-tight mb-4 text-white uppercase tracking-tight" data-id="element-88">
        Convertí tu físico en una ventaja{' '}
        <span className="text-accent-base" data-id="element-89">REAL</span> y definí tus partidos en
        8 semanas
      </h1>

      <div className="w-3/4 max-w-sm mx-auto mb-6 relative" data-id="element-90">
        <div className="absolute inset-0 bg-accent-base/20 blur-2xl rounded-full" data-id="element-91"></div>
        <img src="https://cdn.magicpatterns.com/uploads/t1Hm3VBmY7Fx7GcKZcG95q/ChatGPT_Image_May_16,_2026,_10_07_56_AM.png" alt="Handball Performance Pro 3 Tomos" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-92" />
      </div>

      <p className="text-lg md:text-xl text-gray-300 font-medium mb-8 max-w-2xl" data-id="element-93">
        El sistema definitivo para jugadores y jugadoras de handball que no se
        conforman
      </p>

      <button onClick={scrollToBuy} className="w-full max-w-sm bg-accent-base hover:bg-accent-dark text-white font-oswald text-xl md:text-2xl py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(232,93,44,0.4)] transition-all transform hover:scale-105 active:scale-95 flex flex-col items-center justify-center gap-1 uppercase tracking-wide" data-id="element-94">
        <span data-id="element-95">QUIERO CAMBIAR MI JUEGO</span>
        <span className="text-xs font-sans normal-case text-white/80" data-id="element-96">
          Acceso inmediato • Pago seguro
        </span>
      </button>
    </section>;
}